import { render, staticRenderFns } from "./DeadlineDeleteButton.vue?vue&type=template&id=45c93fea"
import script from "./DeadlineDeleteButton.vue?vue&type=script&lang=js"
export * from "./DeadlineDeleteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports